import { useState } from 'react';

const useCashPayment = () => {
  const [showCashPaymentModal, setShowCashPaymentModal] = useState(false);
  const [cashReceived, setCashReceived] = useState('');
  const [cashChange, setCashChange] = useState(0);

  const calculateChange = (totalAmount) => {
    const receivedAmount = parseFloat(cashReceived) || 0;
    return receivedAmount - totalAmount;
  };

  const validateCashPayment = (totalAmount) => {
    const receivedAmount = parseFloat(cashReceived) || 0;
    if (receivedAmount < totalAmount) {
      return {
        valid: false,
        error: `Otrzymana kwota (${receivedAmount.toFixed(2)} zl) jest mniejsza od naleznosci (${totalAmount.toFixed(2)} zl)`
      };
    }
    return { valid: true, change: receivedAmount - totalAmount };
  };

  const resetCashPaymentModal = () => {
    setCashReceived('');
    setCashChange(0);
    setShowCashPaymentModal(false);
  };

  return {
    showCashPaymentModal,
    setShowCashPaymentModal,
    cashReceived,
    setCashReceived,
    cashChange,
    setCashChange,
    calculateChange,
    validateCashPayment,
    resetCashPaymentModal
  };
};

export default useCashPayment;
